export const providerInstitutionConstant = {
    id: 1,
    value: 'pay',
    label: 'Paysys',
};

export const statusConstant = {
    activeValue: '01',
    inactiveValue: '03',
    lockedValue: '04',
    blockValue: '05',
};


export const otpConstant = {
    sms: "SMS",
    email: "EMAIL",
    both: "BOTH"
};

export const otpOptions = [
    { value: otpConstant.sms, label: "SMS" },
    { value: otpConstant.email, label: "Email" },
    { value: otpConstant.both, label: "Both" },
];

export const statusOptions = [
    { value: statusConstant.activeValue, label: "Active" },
    { value: statusConstant.inactiveValue, label: "In-Active" },
    // { value: statusConstant.lockedValue, label: "Locked" },
];

export const statusOptionsBoolean = [
    { value: true, label: "Active" },
    { value: false, label: "In-Active" },
];